module.exports = __webpack_public_path__ + "img/foresight.44d88e5a.png";